<ion-content>
    <ion-header>
        <ion-item *ngIf="multiple" lines="full">
            <ion-item slot="start" lines="none">
                <ion-label position="stacked" class="clickEnable"
                           (click)="removeSelection()">
                    {{'select.multiple.remove' | translate}}
                </ion-label>
                <ion-icon size="large" name="close"
                          (click)="removeSelection()">
                </ion-icon>
            </ion-item>
            <ion-item slot="end" lines="none">
                <ion-label position="stacked" class="clickEnable"
                           (click)="submit()">
                    {{'select.multiple.submit' | translate}}
                </ion-label>
                <ion-icon size="large" name="checkmark"
                          (click)="submit()"></ion-icon>
            </ion-item>
        </ion-item>
    </ion-header>
    <ion-list #itemList>
        <ion-item *ngFor="let item of selectList">
            <ion-label class="checkName"
                       (click)="selectItem(item)">
                {{ item.name }}
            </ion-label>
            <ion-icon *ngIf="!item.selected" class="unCheckedIcon" slot="end"
                      name="radio-button-off"
                      (click)="selectItem(item)">
            </ion-icon>
            <ion-icon *ngIf="item.selected" class="checkedIcon" slot="end"
                      name="checkmark-circle-outline"
                      (click)="selectItem(item)">
            </ion-icon>
        </ion-item>
    </ion-list>
</ion-content>
